import './style.sass';

import React from 'react';

import CrewContainer from '../../layouts-components__common-cases/crew-container';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const team = {
    crewList: [
        {
            crewItemImg: '',
            crewItemTitle: 'Полина Герасимова ',
            crewItemSubtitle: 'Менеджер проекта',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Павел Воробьев',
            crewItemSubtitle: 'Руководитель фронтенд-направления',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Петр Кленкин',
            crewItemSubtitle: 'Бэкенд-тимлид',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Евгений Терещенко',
            crewItemSubtitle: 'Руководитель отдела бизнес-аналитиков',
        },
        {
            crewItemImg: '',
            crewItemTitle: '2 бэкенд-разработчика',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Фронтенд-разработчик',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '2 QA-инженера',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'DevOps-инженер',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '',
            crewItemTitle: '2 UX/UI-дизайнера',
            crewItemSubtitle: '',
        },
    ],
};

const Team: React.FC  = () => (
    <div className="aimed-team">
        <FullWrapper>
            <div className="aimed-team__Title">Команда</div>
            <CrewContainer container={team} />
        </FullWrapper>
    </div>
);

export default Team;